import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";

import { ThreeBounce } from "commons";

class LoadingComponent extends PureComponent {
    render() {
        if (this.props.displayWhen) {
            return this.props.children;
        }

        let colour;
        if (this.props.colour) {
            colour = this.props.colour;
        } else if (this.props.theme) {
            colour = this.props.theme.primary;
        } else {
            colour = "#f78f21";
        }

        return (
            <div
                className={this.props.className}
                data-testid={this.props["data-testid"] || "loading-indicator"}
            >
                <ThreeBounce data-testid="three-bounce" size={this.props.size} color={colour} />
            </div>
        );
    }
}

LoadingComponent.defaultProps = {
    size: 10
};

LoadingComponent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    className: PropTypes.string,
    displayWhen: PropTypes.bool,
    size: PropTypes.number,
    colour: PropTypes.string,
    theme: PropTypes.shape({
        primary: PropTypes.string
    }),
    "data-testid": PropTypes.string
};

export const Loading = withTheme(LoadingComponent);
